import React from "react";
import { withModal } from "../hoc";
import { ProjectCreateForm } from "../forms";
import { Button } from "semantic-ui-react";

const ButtonWithModal = withModal(ProjectCreateForm, Button);

const ProjectCreateButton = () => (
  <ButtonWithModal
    triggerProps={{ color: "teal", content: "New Project" }}
    modalProps={{ header: "Create New Project" }}
  />
);

export default ProjectCreateButton;
